module.exports = __webpack_public_path__ + "img/ar.ar64f1924.svg";